export const Content = () => {
    return (
        <div className="flex flex-col">
            <div className="flex items-center gap-4 m-5 max-sm:justify-center">
                <img
                    className="w-1/2 shadow-xl rounded-xl"
                    src="/bg-image0.jpg"
                    alt="default"
                />
                <img
                    className="w-1/2 shadow-xl rounded-xl"
                    src="/bg-image1.jpg"
                    alt="default"
                />
            </div>

            <label className="w-full inline-block p-5 max-sm:p-1">
                <h1 className="mb-2 text-4xl font-extrabold text-gray-800 drop-shadow-lg dark:text-white md:text-4xl lg:text-4xl max-sm:text-center max-sm:text-2xl">
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-300 to-red-500">
                        Colorize
                    </span>{" "}
                    black and white photos.
                </h1>
                <p className="text-md text-gray-600 font-normal lg:text-md dark:text-gray-400 max-sm:text-justify ">
                    Using{" "}
                    <a
                        href="https://deepai.org/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-sky-600"
                    >
                        Deep AI
                    </a>{" "}
                    technology we can transform your old black and white photos
                    into beautiful colorized photos.
                </p>
            </label>
        </div>
    );
};
